import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

// Premium HabitsListPage - NO EXTRA IMPORTS (icons switched to emojis)
// Tailwind + framer-motion only

export default function HabitsListPage() {
  const { t } = useTranslation();

  const cards = [
    {
      id: "mobile",
      to: "/dashboard/student/habits/mobile",
      title: t("habits.mobileTitle"),
      desc: t("habits.mobileDesc"),
      icon: "📱",
      accent: "from-pink-300 to-rose-200",
    },
    {
      id: "food",
      to: "/dashboard/student/habits/food",
      title: t("habits.foodTitle"),
      desc: t("habits.foodDesc"),
      icon: "🍎",
      accent: "from-emerald-200 to-lime-100",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-indigo-50 flex flex-col items-center py-12 px-6">

      {/* Header */}
      <div className="w-full max-w-4xl">
        <motion.header
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between gap-4 mb-8"
        >
          <div>
            <p className="mt-1 text-sm text-slate-600">
              { t("habits.title")}
            </p>
          </div>
        </motion.header>
      </div>

      {/* Cards grid */}
      <div className="w-full max-w-4xl grid grid-cols-1 sm:grid-cols-2 gap-6">
        {cards.map((c, idx) => (
          <Link key={c.id} to={c.to} className="group">
            <motion.div
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * idx }}
              whileHover={{ translateY: -6, boxShadow: "0 20px 40px rgba(2,6,23,0.12)" }}
              className={`relative overflow-hidden rounded-2xl p-6 bg-gradient-to-br ${c.accent} bg-opacity-30 border border-white/40 shadow-lg backdrop-blur-sm transition-all group-hover:scale-[1.01]`}
            >
              {/* Decorative blurred circle */}
              <div className="pointer-events-none absolute -right-10 -top-8 w-40 h-40 rounded-full bg-white/30 blur-3xl opacity-60"></div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-white/80 border border-white/60 flex items-center justify-center shadow-sm text-3xl">
                  {c.icon}
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-slate-900">
                    {c.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-700/90 leading-relaxed">
                    {c.desc}
                  </p>

                  <div className="mt-4 flex items-center justify-between">
                    <div className="text-xs font-medium text-slate-800 opacity-90">→</div>
                  </div>
                </div>
              </div>

            </motion.div>
          </Link>
        ))}
      </div>

    </div>
  );
}
